import { RichText, RichTextField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import { ComponentWithContextProps } from 'lib/component-props';
import useHelpers from '../../../../hooks/helpers';

type ParagraphProps = ComponentWithContextProps & {
  fields: {
    description: RichTextField;
  };
};

const Paragraph = ({ fields, rendering, sitecoreContext }: ParagraphProps): JSX.Element => {
  const haveDescriptionValue: boolean = !!fields?.description?.value;
  const { anchorId } = useHelpers(rendering);

  return (
    <div id={anchorId} className="mt-2 mb-3">
      {(sitecoreContext.pageEditing || haveDescriptionValue) && (
        <RichText
          className="body-default text-grey background-to-change"
          field={fields.description}
        />
      )}
    </div>
  );
};

export default withDatasourceCheck()<ParagraphProps>(Paragraph);
